import { PokeType } from "./poke-type.js";

export interface PokeData {
  id: number;
  name: string;
  height: number;
  weight: number;
  types: readonly [PokeType, PokeType?];
  api_moves: readonly string[];
  moves: readonly string[];
  evolution_chain: PokeEvolutionChain;
  stats: {
    resistance: number;
    speed: number;
    ability_power: number;
  };
  stat_changes: ReadonlyArray<{
    stat: "resistance" | "speed" | "ability_power";
    change: number;
    reason: string;
    version: string;
  }>;
  base_experience: number;
  catch_rate: number;
  is_legendary: boolean;
  is_mythical: boolean;
  is_mega: boolean;
  is_gmax: boolean;
  regional_variant: "alola" | "galar" | "hisui" | "paldea" | null;
}

export interface PokeEvolutionChain {
  id: number;
  item: { name: string } | null;
  species: ReadonlyArray<{
    name: string;
    types: readonly [PokeType, PokeType?];
    order: number;
    evolves_from_species_id: number | null;
    pokemonevolutions: ReadonlyArray<{
      type: PokeType | null;
      min_level: number | null;
      item: { name: string } | null;
      location: { name: string } | null;
      min_happiness: number | null;
      min_affection: number | null;
      min_beauty: number | null;
      move: { name: string } | null;
      relative_physical_stats: number | null;
      time_of_day: string | null;
      trade_species_id: number | null;
      turn_upside_down: boolean | null;
      evolutiontrigger: { name: EvolutionTriggerName } | null;
      gender: { name: string } | null;
      held_item_name: string | null;
    }>;
  }>;
}

export enum EvolutionTriggerName {
  LEVEL_UP = "level-up",
  USE_ITEM = "use-item",
  TRADE = "trade",
  EVOLUTION = "evolution",
  OTHER = "other",
}
